import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["hidden", "toggle"];

  connect() {
    this.updateToggleText();
  }

  toggle() {
    this.hiddenTarget.classList.toggle("hidden");
    this.updateToggleText();
  }

  updateToggleText() {
    this.toggleTarget.textContent = this.hiddenTarget.classList.contains("hidden") ? "New Column" : "Cancel";
  }
}
